import { Link } from 'react-router-dom';
import logo from '../assets/img/leveltry.png';

export function Logo({ homeLabel }) {
  return (
    <Link to="/" className="brand" aria-label={homeLabel}>
      <img src={logo} alt="Leveltry" className="brand-mark" />
      <span className="brand-name">Leveltry</span>
    </Link>
  );
}

export function PrimaryButton({ children, to = '/#contacto', className = '' }) {
  if (to.startsWith('/#') || to.startsWith('#')) {
    return (
      <a href={to} className={`btn btn-primary ${className}`.trim()}>
        {children}
      </a>
    );
  }

  return (
    <Link to={to} className={`btn btn-primary ${className}`.trim()}>
      {children}
    </Link>
  );
}

export function GhostButton({ children, to = '/#servicios', className = '' }) {
  if (to.startsWith('/#') || to.startsWith('#')) {
    return (
      <a href={to} className={`btn btn-ghost ${className}`.trim()}>
        {children}
      </a>
    );
  }

  return (
    <Link to={to} className={`btn btn-ghost ${className}`.trim()}>
      {children}
    </Link>
  );
}

export function SectionIntro({ eyebrow, title, description, align = 'left' }) {
  return (
    <div className={`section-intro section-intro--${align}`}>
      {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
      <h2>{title}</h2>
      {description ? <p className="section-copy">{description}</p> : null}
    </div>
  );
}
